module.exports = __webpack_public_path__ + "media/my_images/detail/access-5b4c57f96a2e314b83ae62a33087a6fc.svg";